import React, { useEffect } from "react";
import style from "./Img.module.scss";
import { useSignal } from "@preact/signals-react";
import cls from "classnames";
import isBlank from "@sedan-utils/is-blank";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
export var Img = function Img(props) {
  var showErrorImg = useSignal(true);
  function imgError() {
    showErrorImg.value = true;
  }
  var imgLoaded = function imgLoaded(e) {
    if (!props.imgHeight) return;
    var idArr = ["c3Img", "c4Img"];
    // 如果是占位图加载，设置固定高度
    if (idArr.includes(e.target.id)) {
      props.imgHeight.value = 150;
      return;
    }
    props.imgHeight.value = e.target.clientHeight;
  };
  function isValidUrl(url) {
    try {
      new URL(url);
      return true;
    } catch (err) {
      return false;
    }
  }
  useEffect(function () {
    // 替换key后需要重新加载
    showErrorImg.value = false;
  }, [props.imgKey]);
  return /*#__PURE__*/React.createElement("div", {
    className: cls(style.imgBox, style[props.className], props.expanded ? style.expanded : style.shrinked)
  }, showErrorImg.value || isBlank(props.imgKey) || !isValidUrl(props.imgKey) ? /*#__PURE__*/React.createElement("div", {
    className: style.errorImg
  }, /*#__PURE__*/React.createElement("img", {
    id: props.className,
    src: "".concat(settings.S3CDN).concat(settings.viewAssetsPath, "error-img.png"),
    onLoad: imgLoaded
  })) : /*#__PURE__*/React.createElement("img", {
    src: props.imgKey,
    onError: imgError,
    onLoad: imgLoaded
  }));
};